// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__2w0GL","content":"Modal_content__2kI2g","backdrop":"Modal_backdrop__BTqBt"};